import { createHttpClient } from "./fetchClient";

// Helper to get token from localStorage
const getAuthToken = (): string | null => {
  return localStorage.getItem("accessToken");
};

export const createAuthenticatedClient = (baseURL: string) => {
  const client = createHttpClient(baseURL);

  const getAuthHeaders = (): Record<string, string> => {
    const token = getAuthToken();
    if (!token) {
      return {};
    }

    return { Authorization: `Bearer ${token}` };
  };

  return {
    get: <T>(url: string, options?: RequestInit) =>
      client.get<T>(url, {
        ...options,
        headers: {
          ...options?.headers,
          ...getAuthHeaders(),
        },
      }),

    post: <T>(url: string, body?: unknown, options?: RequestInit) =>
      client.post<T>(url, body, {
        ...options,
        headers: {
          ...options?.headers,
          ...getAuthHeaders(),
        },
      }),

    put: <T>(url: string, body?: unknown, options?: RequestInit) =>
      client.put<T>(url, body, {
        ...options,
        headers: {
          ...options?.headers,
          ...getAuthHeaders(),
        },
      }),

    patch: <T>(url: string, body?: unknown, options?: RequestInit) =>
      client.patch<T>(url, body, {
        ...options,
        headers: {
          ...options?.headers,
          ...getAuthHeaders(),
        },
      }),

    delete: <T>(url: string, options?: RequestInit) =>
      client.delete<T>(url, {
        ...options,
        headers: {
          ...options?.headers,
          ...getAuthHeaders(),
        },
      }),
  };
};
